export const RETRY_COUNT = 1;

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
  HEAD: "HEAD",
  OPTIONS: "OPTIONS",
} as const;

export const OTP_PURPOSE = {
  AUTH_ACTIONS: 1,
  DETAILS_VERIFICATION: 2,
  CREATOR_EMAIL_UPDATION: 3,
  CREATOR_PHONE_NUMBER_UPDATION: 4,
  EUD_EMAIL_LOGIN: 5,
  EUD_PHONE_NUMBER_LOGIN: 6,
};

export const TOKEN_TYPE = {
  CREATOR_TOOL: 1,
  HOST_PAGES: 2,
  CUSTOMER_LOGIN: 3,
  AFFILIATE_PORTAL: 4,
};

export const JWT_GRANT_TYPES = {
  AUTHORIZATION_CODE: "authorization_code",
  REFRESH_TOKEN: "refresh_token",
};
export const JWT_TOKEN_HEADER_KEY = "jwt-token";

export const LOGIN_INPUT_TYPE = {
  EMAIL: 1,
  PHONE: 2,
  GOOGLE: 3,
};

export const REFRESH_TOKEN_EXPIRED_STATUS_CODE = 7;

export const DEFAULT_PAGE_SIZE = 50;
export const INITIAL_PAGE = 1;
export const FIVE_MINUTE_STALE_TIME = 60 * 1000 * 5;
